import React, { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { motion } from "framer-motion";
import "react-toastify/dist/ReactToastify.css";
import {
  requestNotificationPermission,
  subscribeToForegroundMessages,
  updateFCMToken,
} from "../../firebase/notifications";
import { useSelector } from "react-redux";
import "./Notification.css";

const Notification = () => {
  const user = useSelector((state) => state.user);

  useEffect(() => {
    const initializeNotifications = async () => {
      try {
        const token = await requestNotificationPermission();
        if (token && user?._id) {
          await updateFCMToken(token, user._id);
          localStorage.setItem("fcmToken", token);
        }
      } catch (error) {
        console.error("Error initializing notifications:", error);
      }
    };

    const unsubscribe = subscribeToForegroundMessages((payload) => {
      toast(
        ({ closeToast }) => (
          <motion.div
            className="notification-toast-wrapper"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <div className="notification-toast-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2C8.13 2 5 5.13 5 9V16C5 16.55 4.55 17 4 17H3C2.45 17 2 17.45 2 18C2 18.55 2.45 19 3 19H21C21.55 19 22 18.55 22 18C22 17.45 21.55 17 21 17H20C19.45 17 19 16.55 19 16V9C19 5.13 15.87 2 12 2Z"
                  fill="#0c8ce9"
                />
                <path
                  d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22Z"
                  fill="#0c8ce9"
                />
              </svg>
            </div>

            <div className="notification-toast-content">
              <div className="notification-toast-header">
                <h4 className="notification-toast-title">
                  {payload.data?.title || "New Notification"}
                </h4>
                <span className="notification-toast-time">
                  {new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </span>
              </div>
              <p className="notification-toast-body">
                {payload.data?.body || "You have a new notification"}
              </p>
              {payload.data?.actionUrl && (
                <button
                  className="notification-toast-action"
                  onClick={() => window.open(payload.data.actionUrl, "_blank")}
                >
                  View Details
                </button>
              )}
            </div>
          </motion.div>
        ),
        {
          position: "bottom-right",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    });

    initializeNotifications();
    return () => unsubscribe && unsubscribe();
  }, [user]);

  return (
    <ToastContainer
      toastClassName="notification-toast-container"
      bodyClassName="notification-toast-body-wrapper"
      position="top-right"
      newestOnTop
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};

export default Notification;
